import * as Core from '@skylab-shared/core';

// PAYMENT FORMS
export class FiscalDevicePaymentMethodsParametersMappingModel extends Core.ModelBase {

    @Core.Property()
    public mapped: string;

    @Core.Property({ nullable: true })
    public paymentMethodId: number;

}

export class FiscalDevicePaymentMethodsParametersModel extends Core.ModelBase {

    @Core.Collection({ type: FiscalDevicePaymentMethodsParametersMappingModel })
    public mappings: Core.ObservableCollection<FiscalDevicePaymentMethodsParametersMappingModel>;
}

// VAT RATES
export class FiscalDeviceVatRatesParametersMappingModel extends Core.ModelBase {

    @Core.Property()
    public mapped: string;

    @Core.Property({ nullable: true })
    public value: number;

    @Core.Property({ nullable: true })
    public vatRateId: number;

}

export class FiscalDeviceVatRatesParametersModel extends Core.ModelBase {

    @Core.Collection({ type: FiscalDeviceVatRatesParametersMappingModel })
    public mappings: Core.ObservableCollection<FiscalDeviceVatRatesParametersMappingModel>;

    @Core.Property({ nullable: true })
    public technicalZero: string;

}
